module.exports = __webpack_public_path__ + "static/media/File-opened-small.84ef61f5.svg";